angular.module('impactx.deliverycomplaint').controller('ComplaintItemDialogCtrl', ComplaintItemDialogCtrl);

ComplaintItemDialogCtrl.$inject = ['$scope', '$mdDialog', 'dataGen', 'cphId', 'dnhId'];

function ComplaintItemDialogCtrl($scope, $mdDialog, dataGen, cphId, dnhId)
{
    $scope.selectedItems = [];
    $scope.cnhId = cphId;
    $scope.dnhId = dnhId;
    
    var ctrl = this;
    
    ctrl.accept = function(){
        $mdDialog.hide($scope.selectedItems);
    };
    
    ctrl.closeDialog = function(event){
        $mdDialog.hide();
    };
    
    ctrl.toggleSelectItem = function(item){
        if(item.selected){
            var index = $scope.selectedItems.indexOf(item);
            $scope.selectedItems.splice(index, 1);
        }
        else
        {
            $scope.selectedItems.push(item);
        }
        item.selected = !item.selected;
    };
    
    var temp = {};
    var params = {
        dnhId: $scope.dnhId
    };
    dataGen.getData(temp, params, "/deliverycomplaint/additem").then(function(){
        $scope.data = temp.data;
        $scope.trns = temp.trns;
    });
}
